var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("emd-modal", {
    attrs: {
      "has-header": "",
      "has-footer": "",
      "footer-buttons-on-right": "",
      open: _vm.isModalOpen,
    },
    on: { close: _vm.handleClose },
    scopedSlots: _vm._u(
      [
        {
          key: "header",
          fn: function () {
            return [
              _vm.$slots.header
                ? _vm._t("header")
                : _c("emd-text", [_vm._v(" " + _vm._s(_vm.title) + " ")]),
            ]
          },
          proxy: true,
        },
        {
          key: "content",
          fn: function () {
            return [
              _c(
                "div",
                { attrs: { "data-testid": "modal-content" } },
                [
                  _vm.$slots.content
                    ? _vm._t("content")
                    : _c("emd-text", [
                        _vm._v(" " + _vm._s(_vm.description) + " "),
                      ]),
                ],
                2
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "footer",
          fn: function () {
            return [
              _vm.showButtonClose
                ? _c(
                    "emd-button",
                    {
                      attrs: {
                        type: "text",
                        color: "primary",
                        "data-testid": "close-modal",
                      },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v(" " + _vm._s(_vm.computedButtonExitLabel) + " ")]
                  )
                : _vm._e(),
              _vm._t("actions"),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }